import { useState, useEffect } from 'react';
import { useUserStore } from '@/store/userStore';
import { getSubscriptionTypes } from '@/services/edgeFunctionWrappers/subscriptionTypesWrapper';
import { SubscriptionType } from '@/types/subscriptionType';

export function useGymSubscriptionTypes() {
  const { gymId } = useUserStore();
  const [types, setTypes] = useState<SubscriptionType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (gymId) {
      setIsLoading(true);
      getSubscriptionTypes(gymId, false)
        .then(setTypes)
        .catch(console.error)
        .finally(() => setIsLoading(false));
    }
  }, [gymId]);

  return { types, isLoading };
}
